import { Label } from "@screencloud/screencloud-ui-components";
import { FormattedMessage } from "react-intl";
import { CompareChangeType } from "../../types";
import { CHANGE_STATUS_COLORS, hasStatusLabel } from "../../utils/changeStatus";
import { LabelText } from "./styles";

export interface ChangeStatusLabelProps {
  changeType: CompareChangeType;
  /** Disambiguates the test id when the same change type appears more than once. */
  idSuffix?: string;
}

interface StatusMessage {
  id: string;
  defaultMessage: string;
}

const STATUS_MESSAGES: Record<
  Exclude<CompareChangeType, "unchanged">,
  StatusMessage
> = {
  added: { id: "compare_changes.status.added", defaultMessage: "Added" },
  edited: { id: "compare_changes.status.edited", defaultMessage: "Edited" },
  removed: { id: "compare_changes.status.removed", defaultMessage: "Removed" },
  reordered: {
    id: "compare_changes.status.reordered",
    defaultMessage: "Reordered",
  },
};

export const ChangeStatusLabel = ({
  changeType,
  idSuffix,
}: ChangeStatusLabelProps) => {
  if (!hasStatusLabel(changeType)) {
    return null;
  }

  const colors = CHANGE_STATUS_COLORS[changeType];
  if (!colors) {
    return null;
  }

  const message = STATUS_MESSAGES[changeType as keyof typeof STATUS_MESSAGES];
  const testId = `change-status-${changeType}${idSuffix ? `-${idSuffix}` : ""}`;

  return (
    <Label
      circular
      customColor={colors.background}
      textColor={colors.text}
      data-testid={testId}
    >
      <LabelText $color={colors.text}>
        <FormattedMessage
          id={message.id}
          defaultMessage={message.defaultMessage}
        />
      </LabelText>
    </Label>
  );
};
